import * as React from "react";
const SunSvg = ({ height, color, width }) => (
    <svg
        width={width} height={height}
        viewBox="0 0 61 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M30.667 3.625C31.7025 3.625 32.542 4.46447 32.542 5.5V8C32.542 9.03552 31.7025 9.875 30.667 9.875C29.6315 9.875 28.792 9.03552 28.792 8V5.5C28.792 4.46447 29.6315 3.625 30.667 3.625Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.292 30.5C16.292 22.5609 22.7279 16.125 30.667 16.125C38.606 16.125 45.042 22.5609 45.042 30.5C45.042 38.439 38.606 44.875 30.667 44.875C22.7279 44.875 16.292 38.439 16.292 30.5ZM30.667 19.875C24.799 19.875 20.042 24.632 20.042 30.5C20.042 36.368 24.799 41.125 30.667 41.125C36.535 41.125 41.292 36.368 41.292 30.5C41.292 24.632 36.535 19.875 30.667 19.875Z"
            fill={color}
        />
        <path
            d="M14.3151 11.4966C13.5828 10.7643 12.3957 10.7643 11.6634 11.4966C10.9312 12.2288 10.9312 13.416 11.6634 14.1482L13.4312 15.916C14.1634 16.6482 15.3506 16.6482 16.0828 15.916C16.8151 15.1838 16.8151 13.9966 16.0828 13.2643L14.3151 11.4966Z"
            fill={color}
        />
        <path
            d="M57.542 30.5C57.542 31.5355 56.7025 32.375 55.667 32.375H53.167C52.1315 32.375 51.292 31.5355 51.292 30.5C51.292 29.4645 52.1315 28.625 53.167 28.625H55.667C56.7025 28.625 57.542 29.4645 57.542 30.5Z"
            fill={color}
        />
        <path
            d="M49.6708 14.1482C50.4031 13.416 50.4031 12.2288 49.6708 11.4966C48.9386 10.7643 47.7513 10.7643 47.0191 11.4966L45.2513 13.2643C44.5191 13.9966 44.5191 15.1837 45.2513 15.916C45.9836 16.6482 47.1708 16.6482 47.9031 15.916L49.6708 14.1482Z"
            fill={color}
        />
        <path
            d="M30.667 51.125C31.7025 51.125 32.542 51.9645 32.542 53V55.5C32.542 56.5355 31.7025 57.375 30.667 57.375C29.6315 57.375 28.792 56.5355 28.792 55.5V53C28.792 51.9645 29.6315 51.125 30.667 51.125Z"
            fill={color}
        />
        <path
            d="M47.9028 45.084C47.1706 44.3517 45.9836 44.3517 45.2513 45.084C44.5191 45.8162 44.5191 47.0035 45.2513 47.7357L47.0191 49.5035C47.7513 50.2357 48.9383 50.2357 49.6706 49.5035C50.4028 48.7712 50.4028 47.584 49.6706 46.8517L47.9028 45.084Z"
            fill={color}
        />
        <path
            d="M10.042 30.5C10.042 31.5355 9.20251 32.375 8.16699 32.375H5.66699C4.63147 32.375 3.79199 31.5355 3.79199 30.5C3.79199 29.4645 4.63147 28.625 5.66699 28.625H8.16699C9.20251 28.625 10.042 29.4645 10.042 30.5Z"
            fill={color}
        />
        <path
            d="M16.0829 47.7357C16.8151 47.0035 16.8151 45.8162 16.0829 45.084C15.3506 44.3517 14.1634 44.3517 13.4312 45.084L11.6634 46.8517C10.9312 47.584 10.9312 48.7712 11.6634 49.5035C12.3957 50.2357 13.5829 50.2357 14.3151 49.5035L16.0829 47.7357Z"
            fill={color}
        />
    </svg>
);
export default SunSvg;
